export default __webpack_public_path__ + "img/Montserrat-Light_be142e6.woff";